import { useReveal } from "./mocks";
import "./inclusive.css";

const QUOTES = [
  { q: "Booked my facial and my partner's shave in one go. First time an app felt made for me too.", name: "Marcus D.", who: "he · Hillcrest",
    img: "https://images.unsplash.com/photo-1522529599102-193c0d76b5b6?crop=faces&cs=srgb&fm=jpg&q=85&w=200&h=200&fit=crop" },
  { q: "At 62 I finally have a self-care app that doesn't shout at me. One text and it's handled.", name: "Elena R.", who: "she · La Jolla",
    img: "https://images.unsplash.com/photo-1566616213894-2d4e1baee5d8?crop=faces&cs=srgb&fm=jpg&q=85&w=200&h=200&fit=crop" },
  { q: "One request, both our appointments, same evening. No seven apps, no phone tag.", name: "Devon K.", who: "they · North Park",
    img: "https://images.unsplash.com/photo-1779497056298-51a5453cbb7a?crop=faces&cs=srgb&fm=jpg&q=85&w=200&h=200&fit=crop" },
];

export default function Testimonials() {
  const [ref, cls] = useReveal();
  return (
    <section className="tst" data-testid="testimonials">
      <div ref={ref} className={cls}>
        <div className="tst-grid">
          {QUOTES.map((t, i) => (
            <figure key={t.name} className="tst-card" data-testid={`testimonial-${i + 1}`}>
              <blockquote className="tst-quote">“{t.q}”</blockquote>
              <figcaption className="tst-who">
                <img src={t.img} alt={t.name} loading="lazy" />
                <span><b>{t.name}</b><small>{t.who}</small></span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
